import { render } from "./ModalEscolhaTipo.vue?vue&type=template&id=e754d746&scoped=true"
import script from "./ModalEscolhaTipo.vue?vue&type=script&lang=js"
export * from "./ModalEscolhaTipo.vue?vue&type=script&lang=js"

import "./ModalEscolhaTipo.vue?vue&type=style&index=0&id=e754d746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e754d746"]])

export default __exports__